import { TooltipReference } from 'reakit';
import styled, { css } from 'styled-components';
import IconLabelButton from '../IconLabelButton/IconLabelButton';
import ResultItem from '../ResultItem/ResultItem';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 2rem;
  right: 4rem;
`;
export const ResultItemWrapper = styled.div`
  position: relative;
  transition: left 0.5s;
  left: ${(props) => (props.visible ? '0' : 'calc(100% + 5rem)')};
  box-shadow: 0px 16px 10px -20px #000;
  max-width: 21rem;
  z-index: 1;
`;
export const SlideButtonWrapper = styled.div`
  position: absolute;
  right: 0rem;
  bottom: -1rem;
  z-index: 2;
`;
export const StyledResultItem = styled(ResultItem)`
  border: none;
  border-radius: 16px 16px 0 16px;
  padding-bottom: 1.75rem;
`;
export const IconWrapper = styled.span`
  display: flex;
`;
export const SlideButton = styled(IconLabelButton)`
  ${({ theme, visible }) => css`
    border: none;
    position: relative;
    padding: 0.4rem 0.7rem;
    z-index: 1;
    border-radius: 1rem;
    font-size: 0.8rem;
    svg path {
      fill: #fff;
    }
    ${!visible &&
    css`
      background-color: #fff;
      svg path {
        fill: ${theme.color.base};
      }
      &:hover {
        svg path {
          fill: ${theme.color.primary};
        }
      }
    `}
    svg {
      width: 20px;
      height: 20px;
    }
  `}
`;

export const ExamIconWrapper = styled.span`
  display: block;
  width: 100%;
  height: 100%;
`;
